import {
  Container,
  Stack,
  Heading,
  Text,
  Button,
  Box,
  SimpleGrid,
  Image,
  useColorModeValue,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const apiServices = [
  {
    name: 'WooCommerce',
    description: 'Connectez votre boutique WooCommerce et gérez vos commandes facilement.',
    logo: 'https://seeklogo.com/images/W/woo-commerce-logo-85556024CD-seeklogo.com.png',
    route: '/WooCommerce',
  },
  {
    name: 'Shopify',
    description: 'Importez vos commandes Shopify en un clic.',
    logo: 'https://cdn3.iconfinder.com/data/icons/social-media-2068/64/_shopping-512.png',
    route: '/WooCommerce',
  },
  {
    name: 'Magento',
    description: 'Synchronisez vos commandes Magento rapidement.',
    logo: 'https://img.icons8.com/?size=512&id=wO7uLQ2bXGP-&format=png',
    route: '/WooCommerce',
  },
];

function NewOrdersFromAPI() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const bgBox = useColorModeValue('white', 'gray.800');

  return (
    <Container maxW={'7xl'} py={10}>
      <Stack align={'center'} spacing={8}>
        <Heading
          textAlign={'center'}
          fontSize={{ base: '3xl', sm: '4xl', lg: '5xl' }}
          fontWeight={600}
        >
          {t('Importation des données via API')}
        </Heading>
        <Text fontSize={{ base: 'md', sm: 'lg' }} textAlign={'center'} color={'gray.600'}>
          {t("Connectez-vous facilement à vos plateformes e-commerce et importez vos commandes en quelques clics.")}
        </Text>

        {/* Grid des cartes API */}
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6} w="full">
          {apiServices.map((api, index) => (
            <Box
              key={index}
              p={6}
              boxShadow={'lg'}
              rounded={'lg'}
              textAlign={'center'}
              bg={bgBox}
            >
              <Image src={api.logo} alt={api.name} boxSize="80px" mx="auto" mb={4} />
              <Heading fontSize={'xl'}>{api.name}</Heading>
              <Text color={'gray.500'} fontSize={'md'} mt={2}>
                {api.description}
              </Text>
              <Button
                mt={4}
                colorScheme={'purple'}
                size="sm"
                onClick={() => navigate(api.route)}
              >
                {t('Se connecter')}
              </Button>
            </Box>
          ))}
        </SimpleGrid>
      </Stack>
    </Container>
  );
}

export default NewOrdersFromAPI;
